import { getUFValue, getDolarValue } from "./exchangeRateService";
import { client } from "./supabase";

export const getPipelineCobro = async (pais, monedaLocal = "CLP") => {
  const resultado = [];

  const addDias = (fechaStr, dias) => {
    const d = new Date(`${fechaStr}T12:00:00`);
    d.setDate(d.getDate() + dias);
    return d.toISOString().split("T")[0];
  };

  const primerDiaMes = (mesAnio) => {
    const [mm, yyyy] = mesAnio.split("-");
    return `${yyyy}-${mm}-01`;
  };

  const mesSiguiente = (mes, ano) => {
    const m = parseInt(mes, 10);
    const a = parseInt(ano, 10);
    const siguiente = new Date(a, m, 1);
    return siguiente.toISOString().split("T")[0];
  };

  const hoy = new Date().toISOString().split("T")[0];

  const { data: salesData } = await client
    .from("sales")
    .select("id, cliente, importe, moneda_dolar, mes_factura, ano, tipo")
    .eq("pais", pais)
    .eq("estatus", "100%")
    .eq("eliminada", false)
    .is("facturanumero", null);

  for (const s of salesData || []) {
    if (!s.mes_factura) continue;
    let fechaEstimada;
    if (s.tipo === "p") {
      const [mm, yyyy] = s.mes_factura.split("-");
      const ultimoDia = new Date(parseInt(yyyy, 10), parseInt(mm, 10), 0);
      fechaEstimada = addDias(ultimoDia.toISOString().split("T")[0], 60);
    } else {
      const fechaBase = primerDiaMes(s.mes_factura);
      fechaEstimada = addDias(fechaBase, 60);
    }
    if (fechaEstimada <= hoy) continue;

    const importeOriginal = Number(s.importe || 0);
    const importeCLP = s.moneda_dolar
      ? Math.round(importeOriginal * (getDolarValue(fechaEstimada, pais) || 1))
      : importeOriginal;

    resultado.push({
      id: `pipeline-sales-${s.id}`,
      cliente: s.cliente || "—",
      importe: importeOriginal,
      importeCLP,
      moneda_dolar: s.moneda_dolar || false,
      fecha_estimada: fechaEstimada,
      tipo: "pipeline",
      origen: "sales",
    });
  }

  const { data: contratosData } = await client
    .from("sales_contratos")
    .select("id, cliente, meses, moneda_dolar")
    .eq("pais", pais)
    .eq("estatus", "100%")
    .eq("eliminada", false);

  for (const c of contratosData || []) {
    for (const mes of c.meses || []) {
      if (mes.facturanumero) continue;
      if (!mes.mes_factura && !mes.facturafecha) continue;
      const fechaBase = mes.mes_factura ? primerDiaMes(mes.mes_factura) : mes.facturafecha;
      const fechaEstimada = addDias(fechaBase, 60);
      if (fechaEstimada <= hoy) continue;

      const importeOriginal = Number(mes.importe || 0);
      const importeCLP = c.moneda_dolar
        ? Math.round(importeOriginal * (getDolarValue(fechaEstimada, pais) || 1))
        : importeOriginal;

      resultado.push({
        id: `pipeline-contrato-${c.id}-${fechaBase}`,
        cliente: c.cliente || "—",
        importe: importeOriginal,
        importeCLP,
        moneda_dolar: c.moneda_dolar || false,
        fecha_estimada: fechaEstimada,
        tipo: "pipeline",
        origen: "contratos",
      });
    }
  }

  const { data: carteleriaData } = await client
    .from("negocios_carteleria")
    .select(
      "id, nombre_proyecto, referencia_id, tipo_vertical, " +
        "fee_gestion_unitario, fee_contenidos_unitario, incluye_contenidos, " +
        "cuota_hardware_opex, moneda_gestion, moneda_hardware, " +
        "cantidad_pantallas, meses_facturacion, estado, eliminada"
    )
    .eq("pais", pais)
    .eq("eliminada", false)
    .in("estado", ["activo", "100%"]);

  for (const n of carteleriaData || []) {
    const pantallas = parseInt(n.cantidad_pantallas, 10) || 1;
    const mesesFact =
      typeof n.meses_facturacion === "string" ? JSON.parse(n.meses_facturacion || "[]") : n.meses_facturacion || [];

    for (const mf of mesesFact) {
      if (mf.facturanumero) continue;

      const fechaEstimada = mesSiguiente(mf.mes, mf.ano);
      if (fechaEstimada <= hoy) continue;

      let importe = 0;
      let moneda = n.moneda_gestion || monedaLocal;

      if (mf.tipo === "gestion") {
        const fee =
          (parseFloat(n.fee_gestion_unitario) || 0) +
          (n.incluye_contenidos ? parseFloat(n.fee_contenidos_unitario) || 0 : 0);
        importe = fee * pantallas;
        moneda = n.moneda_gestion;
      } else if (mf.tipo === "opex") {
        importe = (parseFloat(n.cuota_hardware_opex) || 0) * pantallas;
        moneda = n.moneda_hardware;
      }

      if (importe <= 0) continue;

      if (moneda === "UF") {
        const ufVal = getUFValue(fechaEstimada) || getUFValue(hoy) || 1;
        importe = Math.round(importe * ufVal);
      } else if (moneda === "USD") {
        const tasa = getDolarValue(fechaEstimada, pais) || 1;
        importe = Math.round(importe * tasa);
      }

      resultado.push({
        id: `pipeline-carteleria-${n.id}-${mf.mes}-${mf.ano}-${mf.tipo}`,
        cliente: n.nombre_proyecto || "—",
        importe,
        moneda_dolar: false,
        fecha_estimada: fechaEstimada,
        tipo: "pipeline",
        origen: "carteleria",
      });
    }
  }

  resultado.sort((a, b) => a.fecha_estimada.localeCompare(b.fecha_estimada));

  return resultado;
};
